import React, { useLayoutEffect } from 'react';
import { Image, StyleSheet } from 'react-native';
import useColors from 'hooks/useColors';
import { IconCalculator, IconRectangleListSolid } from 'design-system/icons';
import IconTransfer from 'design-system/icons/IconTransfer';
import FeatureIntroduction from 'design-system/FeatureIntroduction';
import IconThreeUser from 'design-system/icons/IconThreeUser';
import useColorScheme from 'hooks/useColorScheme';
const GROUPS_ITEMS = [
    {
        icon: <IconRectangleListSolid />,
        title: 'Track shared expenses',
        description: 'Easily see who owes what for meals, trip, or household bills',
    },
    {
        icon: <IconCalculator />,
        title: 'Automatic debt calculation',
        description: 'No need to crunch numbers—Emma does it for you',
    },
    {
        icon: <IconTransfer gradientKey="skyBlue"/>,
        title: 'Settle up seamlessly',
        description: 'Pay instantly and keep things fair',
    },
];
const introLight = require('./img/intro-light.png');
const introDark = require('./img/intro-dark.png');
export const GroupsIntroScreenContent = ({ buttonLabel, onContinue, isInTab, scrollHandler, }) => {
    const colorScheme = useColorScheme();
    const source = colorScheme === 'dark' ? introDark : introLight;
    return (<FeatureIntroduction title="Groups" subTitle={<Image source={source} style={styles.image}/>} titleContainerStyle={styles.titleContainer} items={GROUPS_ITEMS} buttonText={buttonLabel} onPressNext={onContinue} topIcon={<IconThreeUser gradientKey="orange"/>} isInTab={isInTab} scrollHandler={scrollHandler}/>);
};
const GroupsIntroScreen = ({ navigation, route, }) => {
    const colors = useColors();
    useLayoutEffect(() => {
        navigation.setOptions({
            headerTintColor: colors.elements.primary,
        });
    }, [colors.elements.primary]);
    return (<GroupsIntroScreenContent buttonLabel={route.params.buttonLabel} onContinue={route.params.onContinue}/>);
};
const styles = StyleSheet.create({
    titleContainer: {
        paddingHorizontal: 0,
    },
    image: {
        alignSelf: 'center',
        transform: [{ scale: 1.15 }],
        marginTop: -6,
        marginLeft: 8,
        marginBottom: -16,
    },
});
export default GroupsIntroScreen;
